// layouts/MainLayout.jsx
import React, { useEffect } from "react";
import { Toaster } from "@/components/ui/sonner";
import { enableContentProtection } from "@/utils/contentProtection";

export function MainLayout({ children }) {
  // useEffect(() => {
  //   // Only enable content protection in production environment
  //   if (process.env.NODE_ENV === 'production') {
  //     const cleanup = enableContentProtection();
  //     return cleanup;
  //   }
  // }, []);

  return (
    <div className="min-h-screen bg-slate-50/50 flex flex-col">
      {/* Application content rendered inside */}
      {children}

      {/* Global components accessible everywhere */}
      <Toaster />
    </div>
  );
}
